<template>
  <div>

    <legend>Datos del cónyuge, concubina, concubinario y/o dependientes económicos<br></legend>
    <div class="col-12 alert alert-info mb-0">Todos los datos relativos a dependendientes económicos (menores de edad, cónyugue, concubina, concubinario, etc) no seran públicos. </div>

    <div v-if="add_item">

      <div class="row">
        <div class="col-md-4 form-group">
          <label class="control-label">
            Nombre(s)
          </label>
          <input class="form-control" type="text" name="nombres" v-validate="'required'" v-model="model.nombres" placeholder="Nombre(s)" />
          <small class="text-danger">
            {{ getError('nombres') }}
          </small>
        </div>
        <div class="col-md-2 form-group">
          <label class="control-label">
            Primer apellido
          </label>
          <input class="form-control" type="text" name="primer_apellido" v-validate="'required'" v-model="model.primer_apellido" placeholder="Primer apellido" />
          <small class="text-danger" >
            {{ getError('primer_apellido') }}
          </small>
        </div>
        <div class="col-md-2 form-group">
          <label class="control-label">
            Segundo apellido
          </label>
          <input class="form-control" type="text" name="segundo_apellido" v-model="model.segundo_apellido" placeholder="Segundo apellido" />
        </div>
        <div class="col-md-2 form-group" v-if="muestraCampos">
          <label class="control-label">
            Fecha de Nacimiento
          </label>
          <div class="form-group">
              <el-date-picker value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="fecha_posesion"  v-validate="'required'" v-model="model.fecha_nacimiento" :picker-options="opciones" type="date" placeholder="Selecciona">
               </el-date-picker>

            <small class="text-danger" >
              {{ getError('fechanac') }}
            </small>
          </div>
        </div>
        <div class="col-md-2" v-if="muestraCampos">
          <div class="form-group">
            <label class="control-label">
              RFC:
            </label>
            <input class="form-control" type="text" name="rfc" v-validate="'required'" v-model="model.rfc" placeholder="RFC" />
            <small class="text-danger" >
              {{ getError('rfc') }}
            </small>

          </div>
        </div>

        <div class="col-md-12 form-group">
          <label class="control-label">
            Relación con el declarante
          </label>
          <el-select  clearable class="select-default" placeholder="Tipo de relación" name="tipo_relacion" filterable v-validate="'required'" v-model="model.tipo_relacion_dep_id">
            <el-option v-for="option in tiposRelacion" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
            </el-option>
          </el-select>
          <small class="text-danger">
            {{ getError('tipo_relacion') }}
          </small>
        </div>
        <div class="col-md-12 form-group" v-if="model.tipo_relacion_dep_id ==5">
          <label class="control-label">
            Tipo de Relación
          </label>
          <input class="form-control" type="text" name="tipoRelacion" v-validate="'required'" v-model="model.otra_relacion" placeholder="Otra Relación" />
        </div>
        <div class="col-md-6 form-group">
          <label class="control-label">
            Nacionalidad
          </label>
          <el-select  clearable multiple class="select-default" placeholder="Nacionalidades" filterable v-model="model.nac">
            <el-option v-for="option in paisesnac" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              CURP
            </label>
            <input class="form-control" type="text" name="curp" v-validate="'required'" v-model="model.curp" placeholder="CURP" />
            <small class="text-danger" >
              {{ getError('curp') }}
            </small>

          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">
              ¿Es dependiente económico?
            </label>
            <p-radio  class="d-inline-block"  name="ingresos_propios" v-validate="'required'" v-model="model.ingresos_propios" :inline="true" label="1">SI</p-radio>
            <p-radio  class="d-inline-block"  name="ingresos_propios" v-validate="'required'" v-model="model.ingresos_propios" :inline="true" label="2">NO</p-radio>
          </div>
          <small class="text-danger" >
            {{ getError('ingresos_propios') }}
          </small>
        </div>
        <!--<div class="col-md-4" v-if="muestraCampos">
          <div class="form-group">
            <label class="control-label">
              No. Identificación:
            </label>
            <input class="form-control" type="text" name="numero_identificacion_nacional" v-model="model.numero_identificacion_nacional" placeholder="Número de Identificación Oficial" />
          </div>
        </div>
        -->
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">
              ¿Habita en el domicilio del declarante?
            </label>
            <p-radio  class="d-inline-block"  name="habita_domicilio_declarante" v-validate="'required'" v-model="model.habita_domicilio_declarante" :inline="true" label="1">SI</p-radio>
            <p-radio  class="d-inline-block"  name="habita_domicilio_declarante" v-validate="'required'" v-model="model.habita_domicilio_declarante" :inline="true" label="2">NO</p-radio>
          </div>
          <small class="text-danger" >
            {{ getError('habita_domicilio_declarante') }}
          </small>
        </div>
      </div>
      <div v-if="model.habita_domicilio_declarante == 2">
        <domicilio v-model="n_domicilio" ref="Domicilio" titulo=" del Conyuge/ Dependiente"></domicilio>
      </div>

      <div cass="col-md-4" >
          <div class="form-group">
            <label class="control-label"> Actividad laboral</label>
            <br>
            <el-select  clearable class="select-default" v-model="model.ambito_id" width="100%" name="ambitoexp" v-validate="'required'" placeholder="Ámbitos">
              <el-option v-for="option in ambitos" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger" >
              {{ getError('ambitoexp') }}
            </small>
          </div>
      </div>
        <div class="row" v-if="model.ambito_id == 1">
          <!-- Si es ámbito publico se piden los otros datos -->
          <div class="col-md-6 form-group">
            <label class="control-label"> Nivel/Orden de Gobierno </label>
            <br>
            <el-select  clearable class="select-default" placeholder="Nivel" v-model="model.nivel_gobierno_id">
              <el-option v-for="option in niveles" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-6 form-group">
            <label class="control-label"> Ambito público
              <!-- Poder/Naturaleza jurídica-->
            </label><br>
            <el-select  clearable class="select-default" placeholder="Poder" v-model="model.poder_ente_id">
              <el-option v-for="option in poderes" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>

          <div class="col-md-6">
            <label class="control-label">Nombre del ente público</label>
            <input class="form-control" type="text"  name="nombre_dependencia" v-model="model.nombre_dependencia" placeholder="Nombre del ente público" />
            <small class="text-danger" >
              {{ getError('nombre_dependencia') }}
            </small>
          </div>
          <div class="col-md-6">
            <label class="control-label">Área de adscripción</label>
            <input class="form-control" type="text"  name="area_adscripcion" v-model="model.area_adscripcion" placeholder="Área de adscripción" />
            <small class="text-danger" >
              {{ getError('area_adscripcion') }}
            </small>
          </div>

          <div class="col-md-6">
            <label class="control-label">Empleo, cargo o comisión</label>
            <input class="form-control" type="text"  name="empleo_cargo_comision" v-model="model.empleo_cargo_comision" placeholder="Empleo, cargo o comisión" />
            <small class="text-danger" >
              {{ getError('empleo_cargo_comision') }}
            </small>
          </div>
          <div class="col-md-6">
            <label class="control-label">Especifique función principal</label>
            <input class="form-control" type="text"  name="funcion_principal" v-model="model.funcion_principal" placeholder="Especifique función principal" />
            <small class="text-danger" >
              {{ getError('funcion_principal') }}
            </small>
          </div>




      </div>
      <div class="row" v-if="model.ambito_id != 4">
          <div class="row">

            <div class="col-md-12">
              <label class="control-label">Nombre de la empresa, sociedad o asociación</label>
              <input class="form-control" type="text"  name="nombre_empresa" v-model="model.nombre_empresa" placeholder="Nombre de la empresa, sociedad o asociación" />
              <small class="text-danger" >
                {{ getError('nombre_empresa') }}
              </small>
            </div>
          <div class="col-md-6" v-if="muestraCampos">
            <div class="form-group">
              <label class="control-label">
                RFC:
              </label>
              <input class="form-control" type="text" name="rfcempresa"  v-model="model.rfcempresa" placeholder="RFC" />
              <small class="text-danger" >
                {{ getError('rfcempresa') }}
              </small>
            </div>
          </div>
            <div class="col-md-6">
              <label class="control-label">Empleo cargo</label>
              <input class="form-control" type="text"  name="empleo_cargo" v-model="model.empleo_cargo" placeholder="Empleo cargo" />
              <small class="text-danger" >
                {{ getError('empleo_cargo') }}
              </small>
            </div>
      </div>
      </div>
      <div class="row" v-if="model.ambito_id != 4">
          <div class="col-md-6">
            <label class="control-label">Salario mensual neto</label>
            <input class="form-control" type="number" v-validate="'required'"  name="salario_mensual" v-model="model.salario_mensual" placeholder="Salario mensual neto" />
            <small class="text-danger" >
              {{ getError('salario_mensual') }}
            </small>
          </div>
          <div class="col-md-6">
            <label class="control-label">
              Fecha de ingreso al empleo
            </label>
            <div class="form-group">
              <el-date-picker value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="fecha_posesion"  v-validate="'required'" v-model="model.fecha_inicio" :picker-options="opciones" type="date" placeholder="Selecciona">
               </el-date-picker>
              <small class="text-danger" >
                {{ getError('fecha_inicio') }}
              </small>
            </div>
          </div>

      </div>
      <div class="row" v-if="model.ambito_id != 4">
        <div class="col-md-6 form-group  d-inline-block" >
          <label class="control-label">
            ¿Es proveedor o contratista de gobierno?
          </label>
          <p-radio  class="d-inline-block" name="proveedor" v-validate="'required'" v-model="model.proveedor_contratista_gobierno" :inline="true" label="1">SI</p-radio>
          <p-radio  class="d-inline-block" name="proveedor" v-validate="'required'" v-model="model.proveedor_contratista_gobierno" :inline="true" label="2">NO</p-radio>

          <small class="text-danger" >
            {{ getError('proveedor') }}
          </small>
        </div>
        <div class="col-md-6">
          <label class="control-label">
            Sectora al que pertenece:
          </label>
          <el-select  clearable class="select-default" placeholder="Sector" filterable v-model="model.sector_industria_id">
            <el-option v-for="option in sectores" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-12" v-if="muestraCampos">
          <label class="control-label">
           Aclaraciones / observaciones
          </label>
          <textarea class="form-control" type="text" name="observaciones" v-model="model.observaciones" placeholder="Aclaraciones / observaciones" />
        </div>
      </div>

      <div class="row justify-content-end m-3">
        <button class="btn btn-success" @click.prevent="addItem()">
          <span>
            <i class="fa fa-save"></i> Guardar
          </span>
        </button>
        <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
          <span>
            <i class="fa fa-times"></i> Cancelar
          </span>
        </button>
      </div>
    </div>
    <div v-if="!add_item">
      <div class="row justify-content-end m-3">
        <button class="btn btn-primary" @click.prevent="showItem()">
          <span>
            <i class="fa fa-plus"></i> Agregar
          </span>
        </button>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12 col-md-12 col-lg-12">

          <v-data-table id="tbl_exp" responsive hover :items="list_dependientes" :items-per-page="5"  :headers="headers" :fixed-header="true">
            <!-- :fields="fields_list" -->
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="edit_item != null">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>


            <template slot="empty">
              <h5>No existen registros</h5>
            </template>
              <template v-slot:item.tipo_relacion_dep_id="{ item }">
                <div>{{getTipoRel(item.tipo_relacion_dep_id)}}</div>
              </template>

              <template v-slot:item.nombres="{ item }">
                <div>{{getNombre(item)}}</div>
              </template>


          </v-data-table>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from 'element-ui'

  import Domicilio from '../Domicilio.vue'

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },

    data() {
      return {
        opciones: {
          disabledDate(date) {
            return date > new Date();
          }
        },
        validaciones: {
          curp: false,
          rfc: false
        },
        ip_id: null,
        muestraCampos: true,
        datePicker: '',
        model: {
          curp: ''
        },
        list_dependientes: [],
        edit_item: null,
        add_item: false,
        paisesnac: {},
        n_domicilio: {},
        nacionalidadArr: [],
        sectores: {},
        tiposRelacion: {},
        tiposApoyo: {},
        ambitos:[{id:1,valor:"Público"},{id:2,valor:"Privado"},{id:3,valor:"Otro"},{id:4,valor:"Ninguno"}],
        poderes: [],
        niveles: [],
        headers: [{
            text: 'Acciones',
            align: 'center',
            sortable: false,
            value: 'acciones',
            class: ''
          }, {
            text: 'Tipo Relacion',
            value: 'tipo_relacion_dep_id',
            align: 'left',
          },{
            text: 'CURP',
            value: 'curp',
            align: 'left',
          },{
            text: 'Nombre',
            value: 'nombres',
            align: 'left',
          },
        ],

      }
    },
    watch: {
      n_domicilio: {
        handler: function () {
          if (this.n_domicilio) {
            this.model.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
            this.model.domicilio_entidad_federativa = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
            this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.model.domicilio_nombre_vialidad = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.model.domicilio_tipo_vialidad = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";

          }
        },
        deep: true
      }
    },
    methods: {
      getAmbito(index) {
        var resp = "";
        if (this.ambitos) {
          this.ambitos.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getPoder(index) {
        var resp = "";
        if (this.poderes) {
          this.poderes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getNivel(index) {
        var resp = "";
        if (this.niveles) {
          this.niveles.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getPoderes() {
        this.$http.get('poderJuridico').then(response => {
          this.poderes = response.data.poderJuridico;
        }, error => {
          this.StepError(error);
          console.log(error);
        })
      },
      getNivelesG() {
        this.$http.get('nivelGobierno').then(response => {
          this.niveles = response.data.nivelGobierno;
        }, error => {
          this.StepError(error);
          console.log(error);
        })
      },
      editDomicilio() {
        this.n_domicilio.pais_id = this.model.domicilio_pais_id;
        this.n_domicilio.entidadF = this.model.domicilio_entidad_federativa;
        this.n_domicilio.municipio = this.model.domicilio_municipio_id;
        this.n_domicilio.localidad = this.model.domicilio_localidad_id;
        this.n_domicilio.cp = this.model.domicilio_cp;
        this.n_domicilio.colonia = this.model.domicilio_colonia;
        this.n_domicilio.vialidad = this.model.domicilio_tipo_vialidad;
        this.n_domicilio.vialidad_nombre = this.model.domicilio_nombre_vialidad;
        this.n_domicilio.ext = this.model.domicilio_numext;
        this.n_domicilio.int = this.model.domicilio_numint;

      },
      limpiaCampos() {
        this.nacionalidadArr = null;
        this.nacionalidadArr = [];
        this.model = {
          tipo_relacion_dep_id: '',
          nombres: '',
          primer_apellido: '',
          segundo_apellido: '',
          nac: '',
          curp: '',
          rfc: '',
          fecha_nacimiento: '',
          proveedor_contratista_gobierno: '',
          habita_domicilio_declarante: '',
          medio_contacto: '',
          ingresos_propios: '',
          ocupacion_profesion: '',
          sector_industria_id: '',
          tiene_intereses_mismo_sector_declarante: '',
          desarrolla_cabildeo_sector_declarante: '',
          beneficiario_programa_publico: '',
          observaciones: '',
          nom_vial: '',
          tipo_vial: ''
        };


      },
      editItem(indice) {
        this.limpiaCampos()
        this.showItem();
        this.model = indice;
        /*
        this.model = {
          ...this.list_dependientes[this.edit_item.index]
        };
        */

        var v = this;
        $.each(this.model.nac, function (key, value) {
          v.nacionalidadArr.push(value.nac_id);
        })
        this.model.nac = v.nacionalidadArr;
        this.editDomicilio();

        if (this.model.desempenia_admon_pub == '1') {
          this.model.nombre_dependencia = this.model.entidad.nombre_dependencia;
          this.model.fecha_inicio = this.model.entidad.fecha_inicio;
          this.model.fecha_fin = this.model.entidad.fecha_fin;
        }
       // this.edit_item.item._rowVariant = "warning";
        $(".main-panel").animate({
            scrollTop: 1300
          },
          500,
          "swing"
        );
      },
      addItem() {
        this.model.domicilio_pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
        this.model.domicilio_entidad_federativa = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
        this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
        this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
        this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
        this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
        this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
        this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
        this.model.domicilio_nombre_vialidad = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
        this.model.domicilio_tipo_vialidad = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";

        //this.validate().then(
          this.$validator.validateAll().then(
          response => {
            if (response) {
              this.loadButton(this.$refs.btnSave);

              this.$http.put('dependientesEc/' + this.ip_id, this.model).then(
                response => {
                  this.StepOk("Guardado");
                  /* this.origen_tramites = JSON.parse(JSON.stringify(response.data.tramite));
                  eventBus.$emit("TramiteSaved", response.data.tramite);
                  this.envioRespuesta(true); */
                  if (this.edit_item === undefined || this.edit_item === null) {
                    this.list_dependientes.push({
                      ...this.model
                    });
                  } else {
                    this.list_dependientes.splice(
                      this.edit_item.index,
                      1,
                      this.model
                    );
                    //this.edit_item.item._rowVariant = "";
                  }

                  this.showItem();
                  this.limpiaCampos();
                  this.edit_item = null;
                  this.getDependientes()
                },
                error => {
                  this.StepError(error);
                  //this.change =  true;
                }
              );
            } else {
              this.StepW("Hay campos sin completar");
            }

          }
        );


      },
      getSafe(fn, defaultVal) {
        try {
          return fn();
        } catch (e) {
          return defaultVal;
        }
      },
      cancelEdit() {
        if (this.edit_item) {
          //this.edit_item.item._rowVariant = "";
        }
        //this.limpiaCampos();
        this.showItem();
        this.edit_item = null;
      },

      showItem() {
        this.add_item = !this.add_item;
      },
      getDependientes() {
        var v = this;
        this.$http.get('dependientesEc/' + this.ip_id).then(
          response => {
            this.list_dependientes = response.data.dependientes;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
/*       removeItem(item) {
        if (this.item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("dependientesEc/" + item.id).then(
              response => {
                let index = this.list_dependientes.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.list_dependientes.splice(index, 1);
                this.StepOk('Registro eliminado');
              },
              error => {
                this.Err(error);
              }
            );


          });
        }
      }, */
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("dependientesEc/" + item.id).then(
              response => {
                let index = this.list_dependientes.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.list_dependientes.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      getSectores() {
        this.$http.get('cat_sector_industria').then(
          response => {
            this.sectores = response.data.sectores;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      getTipoRel(index) {
        var resp = "";
        if (this.tiposRelacion) {
          this.tiposRelacion.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getTipoApoyo() {
        this.$http.get('tipoApoyo').then(
          response => {
            this.tiposApoyo = response.data.tipos_apoyos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var v = this;
        this.validaciones = {
          curp: false
        }

        let validacurp = new Promise(function (resolve, reject) {
          if (v.add_item && (!v.curpValida(v.getSafe(() => v.model.curp, '')))) {
            v.validaciones.curp = true;
            reject(false)
          } else {
            resolve(true)
          }
        });
        var ddependiente = this.$validator.validateAll()

        return Promise.all([ddependiente, validacurp])
      },
      valida(){
        return this.$validator.validateAll();

      },
      getPaises() {
        this.$http.get('paises').then(
          response => {
            this.paisesnac = response.data.pais;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      getTiposR() {
        this.$http.get('tipoRelacDep').then(
          response => {
            this.tiposRelacion = response.data.tipos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      handleInputConfirm() {
        let inputValue = this.tags.inputValue
        if (inputValue) {
          this.tags.dynamicTags.push(inputValue)
        }
        this.tags.inputVisible = false
        this.tags.inputValue = ''
      },
      getTipoRel(index) {
        var resp = "";
        if (this.tiposRelacion) {
          this.tiposRelacion.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getNombre(item) {
        var resp = (item.nombres ||'')+ " " + (item.primer_apellido ||'' )+ " " + (item.segundo_apellido||'');

        return resp;
      }
    },
    mounted() {

      this.ip_id = this.getId();
      this.getSectores();
      this.getPaises();
      this.getTiposR();
      this.getDependientes();
      this.getPoderes();
      this.getNivelesG();
    }
  }

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Personal/DatosConyuge.vue